// extracted by mini-css-extract-plugin
export default {"navbar":"style_navbar__HxpJV","prev":"style_prev__JjlxL","next":"style_next__ds4Gr","main":"style_main__Z4pR9","wb":"style_wb__4IBXs"};